module.exports = __webpack_public_path__ + "static/img/cont3602.a5dd63e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont3602.jpg
// module id = Fy4P
// module chunks = 0